import { Form } from '@uplift/types';
import { restClient } from '../../client';

export type FormDefinitionForSubmissionOutput =
  | { error: string }
  | { form: Form };

export const getFormDefinitionForSubmission = (submissionId: string) =>
  restClient.request<FormDefinitionForSubmissionOutput>('/api/v1/form/definition/submission', {
    method: 'POST',
    data: {
      submission_id: submissionId
    }
  });
